import React from 'react';
import { useTranslations } from '../../../../../../hooks/useTranslations';
import XCircleIcon from '../../../../../ui/icons/XCircle/XCircle';
import ControlView from '../../ControlView/ControlView';

interface MarketingUnsubscribedProps {
  featureName?: string;
  isLandscape: boolean;
  onSignUpAgainClick: () => void;
}

const MarketingUnsubscribed = ({
  featureName,
  isLandscape,
  onSignUpAgainClick,
}: MarketingUnsubscribedProps) => {
  const {
    notificationCenterSmsUnsubscribedMessage,
    notificationCenterSmsSignupAgain,
  } = useTranslations();

  const notificationCenterSmsUnsubscribedTitle = 'Unsubscribed';

  const handleSignUpAgainClick = () => {
    onSignUpAgainClick();
  };

  return (
    <ControlView
      channel="sms"
      isLandscape={isLandscape}
      featureName={featureName}
      icon={<XCircleIcon />}
      heading={notificationCenterSmsUnsubscribedTitle ?? undefined}
      text={notificationCenterSmsUnsubscribedMessage ?? undefined}
      primaryButton={{
        text: notificationCenterSmsSignupAgain ?? '',
        onClick: handleSignUpAgainClick,
      }}
    />
  );
};

export default MarketingUnsubscribed;
